import { ImpactModule } from 'types'
import { SCHEDULES_PAGES } from './pages'
import { SCHEDULES_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const SCHEDULES_MODULE: ImpactModule = {
  NAME: 'schedule',
  UPPER_NAME: 'SCHEDULE',
  API_NAME: 'SCHEDULE',
  NAME_PTBR: 'Agendas',
  PAGES: SCHEDULES_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: SCHEDULES_PAGES_ORDER_FOR_PERMISSIONS,
}
